'use client';

import Link from 'next/link';
import { ComponentProps, forwardRef } from 'react';
import { getTVShowLink } from './link-utils';
import { useGetChannelLink } from './LinkWithChannel';

interface Props extends Omit<ComponentProps<typeof Link>, 'href'> {
  slug?: string | null;
}

export const TVShowLink = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const getChannelLink = useGetChannelLink();

  if (!props.slug) {
    return (
      <div ref={ref} style={props.style} className={props.className}>
        {props.children}
      </div>
    );
  }
  return (
    <Link
      ref={ref as any}
      {...props}
      href={getChannelLink(getTVShowLink(props.slug as string))}
    />
  );
});

interface PlayProps extends Props {
  contentSlug?: string;
}

export const TVShowPlayLink = ({ contentSlug, slug, ...props }: PlayProps) => {
  const getChannelLink = useGetChannelLink();
  if (!slug) {
    return (
      <div style={props.style} className={props.className}>
        {props.children}
      </div>
    );
  }
  return (
    <Link
      {...props}
      href={getChannelLink(getTVShowLink(slug as string, contentSlug))}
    />
  );
};
